module.exports = __webpack_public_path__ + "static/media/wbtc.942b81cc.svg";